export default {
      id: "editor-underline-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#editor-underline",
      toString: function () {
        return this.url;
      }
    }